import { ChakraProvider } from '@chakra-ui/react';
import { PageNotFound } from '@common/pages/PageNotFound';
import { theme } from '@common/theming/chakra';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import { Asset } from './pages/Asset';
import { Home } from './pages/Home';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ChakraProvider theme={theme}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/asset/:assetId" element={<Asset />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  </ChakraProvider>,
);
